export default "__VITE_ASSET__DZbvhR6t__"